export default "__VITE_ASSET__421c30b3__"